"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var PreventUserSelect_1 = require("../styles/PreventUserSelect");
var TabStyles_1 = require("../styles/TabStyles");
var Colors = TabStyles_1.TabStyles.Colors, Opacity = TabStyles_1.TabStyles.Opacity, Sizing = TabStyles_1.TabStyles.Sizing, Spacing = TabStyles_1.TabStyles.Spacing, Typography = TabStyles_1.TabStyles.Typography;
// webpack barfs if the enum is declared in another file and used here, so moved it here from ButtonWidget
var ButtonType;
(function (ButtonType) {
    ButtonType[ButtonType["Destructive"] = 0] = "Destructive";
    /** @deprecated use `Destructive` */ ButtonType[ButtonType["Attention"] = 0] = "Attention";
    /** @deprecated use `Destructive` */ ButtonType[ButtonType["OutlineAttention"] = 6] = "OutlineAttention";
    ButtonType[ButtonType["Primary"] = 2] = "Primary";
    /** @deprecated use `Primary` */ ButtonType[ButtonType["Go"] = 2] = "Go";
    /** @deprecated use `Primary` */ ButtonType[ButtonType["OutlineGo"] = 5] = "OutlineGo";
    ButtonType[ButtonType["Outline"] = 3] = "Outline";
    /** @deprecated use `Outline` */ ButtonType[ButtonType["Grey"] = 1] = "Grey";
    ButtonType[ButtonType["OutlineDark"] = 4] = "OutlineDark";
    /** @deprecated use `OutlineDark` */ ButtonType[ButtonType["LightOutline"] = 4] = "LightOutline";
    ButtonType[ButtonType["LowEmphasis"] = 9] = "LowEmphasis";
    /** @deprecated use `LowEmphasis` */ ButtonType[ButtonType["Text"] = 7] = "Text";
    /** @deprecated use `LowEmphasis` */ ButtonType[ButtonType["DarkText"] = 8] = "DarkText";
    /** @deprecated use `LowEmphasis` */ ButtonType[ButtonType["DarkBoldText"] = 9] = "DarkBoldText";
    ButtonType[ButtonType["Icon"] = 10] = "Icon";
    ButtonType[ButtonType["IconOutline"] = 11] = "IconOutline";
})(ButtonType = exports.ButtonType || (exports.ButtonType = {}));
function getHorizontalPadding() { return Sizing.RowHeight; }
function getDefaultSpacing() { return Spacing.DefaultSpace; }
exports.getDefaultSpacing = getDefaultSpacing;
function getDefaultDisabledStyle() {
    return {
        backgroundColor: Colors.F7Disabled,
        borderColor: Colors.Transparent,
        color: Typography.Color.Disabled,
    };
}
function getBaseButtonStyle() {
    return tslib_1.__assign({ fontSize: Typography.Sizing.Default, fontWeight: 'normal', color: Typography.Color.Primary, display: 'inline-block', paddingLeft: getHorizontalPadding(), paddingRight: getHorizontalPadding(), paddingTop: 0, paddingBottom: 0, position: 'relative', textAlign: 'center', borderStyle: 'solid', borderWidth: Sizing.BorderWidth, borderRadius: Sizing.BorderRadius, height: Sizing.RowHeight, lineHeight: (Sizing.RowHeight - Sizing.BorderWidth * 2) + 'px', minWidth: Sizing.ButtonMinWidth, boxSizing: 'border-box', outline: 'none', whiteSpace: 'nowrap' }, PreventUserSelect_1.PreventUserSelect);
}
function getAttentionButtonStyle() {
    return {
        base: tslib_1.__assign({}, getBaseButtonStyle(), { backgroundColor: Colors.AttentionLight, borderColor: Colors.AttentionLight, color: Typography.Color.InvertedPrimary }),
        interactive: {
            hover: {
                backgroundColor: Colors.AttentionLight,
                borderColor: Colors.L8,
                color: Typography.Color.InvertedPrimary,
            },
            focus: {
                backgroundColor: Colors.AttentionLight,
                borderColor: Colors.L8,
                color: Typography.Color.InvertedPrimary,
            },
            active: {
                backgroundColor: Colors.AttentionDark,
                borderColor: Colors.AttentionDark,
                color: Typography.Color.InvertedPrimary,
            },
            disabled: getDefaultDisabledStyle(),
        }
    };
}
function getGreyButtonStyle() {
    return {
        base: tslib_1.__assign({}, getBaseButtonStyle(), { backgroundColor: Colors.F5, borderColor: Colors.L5, color: Typography.Color.Primary }),
        interactive: {
            hover: {
                backgroundColor: Colors.F5,
                borderColor: Colors.L8,
                color: Typography.Color.Primary,
            },
            focus: {
                backgroundColor: Colors.F5,
                borderColor: Colors.L8,
                color: Typography.Color.Primary,
            },
            active: {
                backgroundColor: Colors.F8,
                borderColor: Colors.L8,
                color: Typography.Color.InvertedPrimary,
            },
            disabled: getDefaultDisabledStyle(),
        }
    };
}
function getGoButtonStyle() {
    return {
        base: tslib_1.__assign({}, getBaseButtonStyle(), { backgroundColor: Colors.GoLight, borderColor: Colors.GoLight, color: Typography.Color.InvertedPrimary }),
        interactive: {
            hover: {
                backgroundColor: Colors.GoLight,
                borderColor: Colors.L8,
                color: Typography.Color.InvertedPrimary,
            },
            focus: {
                backgroundColor: Colors.GoLight,
                borderColor: Colors.L8,
                color: Typography.Color.InvertedPrimary,
            },
            active: {
                backgroundColor: Colors.GoDark,
                borderColor: Colors.GoDark,
                color: Typography.Color.InvertedPrimary,
            },
            disabled: getDefaultDisabledStyle(),
        }
    };
}
function getOutlineButtonStyle() {
    return {
        base: tslib_1.__assign({}, getBaseButtonStyle(), { backgroundColor: Colors.Transparent, borderColor: Colors.L6, color: Typography.Color.PrimaryMedium }),
        interactive: {
            hover: {
                backgroundColor: Colors.Transparent,
                borderColor: Colors.L8,
                color: Typography.Color.Primary,
            },
            focus: {
                backgroundColor: Colors.Transparent,
                borderColor: Colors.L8,
                color: Typography.Color.PrimaryMedium,
            },
            active: {
                backgroundColor: Colors.F2,
                borderColor: Colors.L9,
                color: Typography.Color.Primary,
            },
            disabled: tslib_1.__assign({}, getDefaultDisabledStyle(), { backgroundColor: Colors.Transparent, borderColor: Colors.L9Disabled, color: Typography.Color.Disabled })
        }
    };
}
function getLightOutlineButtonStyle() {
    return {
        base: tslib_1.__assign({}, getBaseButtonStyle(), { backgroundColor: Colors.Transparent, borderColor: Colors.L6, color: Typography.Color.InvertedPrimary }),
        interactive: {
            hover: {
                backgroundColor: Colors.Transparent,
                borderColor: Colors.White,
                color: Typography.Color.InvertedPrimary,
            },
            focus: {
                backgroundColor: Colors.Transparent,
                borderColor: Colors.White,
                color: Typography.Color.InvertedPrimary,
            },
            active: {
                backgroundColor: Colors.WhiteTransparent,
                borderColor: Colors.White,
                color: Typography.Color.InvertedPrimary,
            },
            disabled: tslib_1.__assign({}, getDefaultDisabledStyle(), { borderColor: Colors.WhiteDisabled, backgroundColor: Colors.Transparent, color: Typography.Color.InvertedDisabled })
        }
    };
}
function getOutlineGoButtonStyle() {
    return {
        base: tslib_1.__assign({}, getBaseButtonStyle(), { backgroundColor: Colors.Transparent, borderColor: Colors.GoLight, color: Typography.Color.PrimaryDark, borderWidth: Sizing.ButtonBorderWidth, lineHeight: (Sizing.RowHeight - Sizing.ButtonBorderWidth * 2) + 'px' }),
        interactive: {
            hover: {
                backgroundColor: Colors.Transparent,
                borderColor: Colors.GoDark,
                color: Colors.Black,
            },
            focus: {
                backgroundColor: Colors.Transparent,
                borderColor: Colors.L8,
                color: Colors.Black,
            },
            active: {
                backgroundColor: Colors.F2,
                borderColor: Colors.GoDark,
                color: Colors.Black,
            },
            disabled: tslib_1.__assign({}, getDefaultDisabledStyle(), { backgroundColor: Colors.Transparent, borderColor: Colors.GoDarkDisabled, color: Typography.Color.Disabled })
        }
    };
}
function getOutlineAttentionButtonStyle() {
    return {
        base: tslib_1.__assign({}, getBaseButtonStyle(), { backgroundColor: Colors.Transparent, borderColor: Colors.AttentionLight, color: Typography.Color.PrimaryDark, borderWidth: Sizing.ButtonBorderWidth, lineHeight: (Sizing.RowHeight - Sizing.ButtonBorderWidth * 2) + 'px' }),
        interactive: {
            hover: {
                backgroundColor: Colors.Transparent,
                borderColor: Colors.AttentionDark,
                color: Colors.Black,
            },
            focus: {
                backgroundColor: Colors.Transparent,
                borderColor: Colors.L8,
                color: Colors.Black,
            },
            active: {
                backgroundColor: Colors.F2,
                borderColor: Colors.AttentionDark,
                color: Colors.Black,
            },
            disabled: tslib_1.__assign({}, getDefaultDisabledStyle(), { backgroundColor: Colors.Transparent, borderColor: Colors.AttentionDarkDisabled, color: Typography.Color.Disabled })
        }
    };
}
function getTextButtonStyle() {
    return {
        base: tslib_1.__assign({}, getBaseButtonStyle(), { fontWeight: 'bold', backgroundColor: Colors.Transparent, borderColor: Colors.Transparent, color: Colors.GoLight }),
        interactive: {
            hover: {
                backgroundColor: Colors.F2,
                borderColor: Colors.F2,
                color: Colors.GoLight,
            },
            focus: {
                backgroundColor: Colors.F2,
                borderColor: Colors.F2,
                color: Colors.GoLight,
            },
            active: {
                backgroundColor: Colors.F2,
                borderColor: Colors.F2,
                color: Colors.GoDark,
            },
            disabled: tslib_1.__assign({}, getDefaultDisabledStyle(), { backgroundColor: Colors.Transparent, borderColor: Colors.Transparent, color: Colors.GoDarkDisabled })
        }
    };
}
function getDarkTextButtonStyle() {
    return {
        base: tslib_1.__assign({}, getBaseButtonStyle(), { backgroundColor: Colors.Transparent, borderColor: Colors.Transparent, color: Typography.Color.Primary }),
        interactive: {
            hover: {
                backgroundColor: Colors.F2,
                borderColor: Colors.F2,
                color: Typography.Color.Primary,
            },
            focus: {
                backgroundColor: Colors.F2,
                borderColor: Colors.F2,
                color: Typography.Color.Primary,
            },
            active: {
                backgroundColor: Colors.F2_5,
                borderColor: Colors.F2_5,
                color: Colors.Black,
            },
            disabled: tslib_1.__assign({}, getDefaultDisabledStyle(), { backgroundColor: Colors.Transparent, borderColor: Colors.Transparent, color: Typography.Color.Disabled })
        }
    };
}
function getDarkBoldTextButtonStyle() {
    return {
        base: tslib_1.__assign({}, getBaseButtonStyle(), { fontWeight: 'bold', backgroundColor: Colors.Transparent, borderColor: Colors.Transparent, color: Typography.Color.Primary }),
        interactive: {
            hover: {
                backgroundColor: Colors.F2,
                borderColor: Colors.F2,
                color: Typography.Color.Primary,
            },
            focus: {
                backgroundColor: Colors.F2,
                borderColor: Colors.F2,
                color: Typography.Color.Primary,
            },
            active: {
                backgroundColor: Colors.F2_5,
                borderColor: Colors.F2_5,
                color: Colors.Black,
            },
            disabled: tslib_1.__assign({}, getDefaultDisabledStyle(), { backgroundColor: Colors.Transparent, borderColor: Colors.Transparent, color: Typography.Color.Disabled })
        }
    };
}
function getBaseIconButtonStyle() {
    return tslib_1.__assign({ alignItems: 'center', color: Typography.Color.PrimaryLight, display: 'inline-flex', fontSize: Typography.Sizing.Default, fontWeight: 'normal', justifyContent: 'center', minHeight: 20, minWidth: 20, outline: 'none' }, PreventUserSelect_1.PreventUserSelect);
}
function getIconButtonStyle() {
    return {
        base: tslib_1.__assign({}, getBaseIconButtonStyle(), { backgroundColor: Colors.Transparent, whiteSpace: 'nowrap' }),
        interactive: {
            hover: {
                backgroundColor: Colors.F3,
                color: Typography.Color.Primary,
            },
            focus: {
                backgroundColor: Colors.F3,
                color: Typography.Color.Primary,
            },
            active: {
                backgroundColor: Colors.F5,
                color: Typography.Color.Primary,
            },
            disabled: {
                color: Typography.Color.Disabled,
                opacity: Opacity.Disabled,
            }
        }
    };
}
function getIconOutlineButtonStyle() {
    return {
        base: tslib_1.__assign({}, getBaseIconButtonStyle()),
        interactive: {
            disabled: {
                opacity: Opacity.Disabled,
            }
        }
    };
}
// tslint:disable:deprecation
var ButtonStyleMap = Object.freeze((_a = {},
    _a[ButtonType.Attention] = getAttentionButtonStyle,
    _a[ButtonType.Destructive] = getAttentionButtonStyle,
    _a[ButtonType.Grey] = getGreyButtonStyle,
    _a[ButtonType.Primary] = getGoButtonStyle,
    _a[ButtonType.Go] = getGoButtonStyle,
    _a[ButtonType.Outline] = getOutlineButtonStyle,
    _a[ButtonType.OutlineDark] = getLightOutlineButtonStyle,
    _a[ButtonType.LightOutline] = getLightOutlineButtonStyle,
    _a[ButtonType.OutlineGo] = getOutlineGoButtonStyle,
    _a[ButtonType.OutlineAttention] = getOutlineAttentionButtonStyle,
    _a[ButtonType.Text] = getTextButtonStyle,
    _a[ButtonType.DarkText] = getDarkTextButtonStyle,
    _a[ButtonType.LowEmphasis] = getDarkBoldTextButtonStyle,
    _a[ButtonType.DarkBoldText] = getDarkBoldTextButtonStyle,
    _a[ButtonType.Icon] = getIconButtonStyle,
    _a[ButtonType.IconOutline] = getIconOutlineButtonStyle,
    _a));
// tslint:enable:deprecation
function getButtonStyle(buttonType) {
    return ButtonStyleMap[buttonType]();
}
exports.getButtonStyle = getButtonStyle;
//# sourceMappingURL=ButtonWidgetStyles.js.map